import { useEffect, useState } from 'react';

export function useReducedMotion() {
  const [reduced, setReduced] = useState(() =>
    Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
  );

  useEffect(() => {
    if (!window.matchMedia) return;
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduced(query.matches);
    query.addEventListener ? query.addEventListener('change', update) : query.addListener(update);
    return () => {
      query.removeEventListener ? query.removeEventListener('change', update) : query.removeListener(update);
    };
  }, []);
  return reduced;
}
